import { format, subMinutes } from 'date-fns'
import { POST } from '@/api'
import { maxBy } from 'lodash'
import { setStorage, getStorage } from '@/utils/localstorageManager'
import labels from './labels'

export default {
  namespaced: true,
  state: {
    newAlerts: [],
  },
  modules: {
    labels,
  },
  mutations: {
    set(state, alerts) {
      state.newAlerts = alerts
    },
  },
  actions: {
    clearNewAlerts({ commit }) {
      commit('set', [])
    },
    async getNewAlerts(store, limit = 20) {
      const { commit } = store
      const { status, message, data } = await POST('/api/web/alert/list', {
        updateTime: getStorage('lastAlertUpdateTime') || format(subMinutes(new Date(), 15), 'YYYYMMDDHHmmss'),
        start: 0,
        limit,
      })

      if (status !== 200) {
        commit('app/error', { status, message }, { root: true })
        return
      }

      const lastHolidayAlertMessage = getStorage('lastHolidayAlertMessage')
      const alerts = Object.keys(data)
        .reduce(
          (result, date) =>
            result.concat(
              data[date].map(reserve => ({
                ...reserve,
                date,
              })),
            ),
          [],
        )
        // 一度表示した定休日アラートは表示しない
        .filter(alert => alert.type > 0 || alert.shortMessage !== lastHolidayAlertMessage)

      // 最新のアラート更新日時を保持
      const lastAlert = maxBy(alerts, 'updateTime')
      if (lastAlert) {
        setStorage('lastAlertUpdateTime', lastAlert.updateTime.replace(/[-: ]/g, ''))
      }

      // 定休日アラートメッセージを保持
      const holidayAlert = alerts.find(alert => alert.type === 0)
      if (holidayAlert) {
        setStorage('lastHolidayAlertMessage', holidayAlert.shortMessage)
      }

      commit('set', alerts)
    },
  },
}
